import { matchPath, NavLink,useLocation } from 'react-router-dom';
import { ImagePath } from '../common/ImagePath';
import { UserRole } from '../../utlis/constant';
import { useGlobalStates } from '../../utlis/ClubsContext';

const Sidebar = ({ onLogoutClick }) => {
  const {userRole} = useGlobalStates();
  const location = useLocation();


  const menuItems = [
    { icon:  ImagePath.Dashicon, label: 'Dashboard', path: '/dashboard' , roles:[UserRole.Admin,UserRole.Editor,UserRole.Viewer]},
    { icon: ImagePath.Adverticon, label: 'Advertiser', path: '/advertiser', matchPaths:[ '/advertiser'] ,roles:[UserRole.Admin, UserRole.Editor,UserRole.Viewer]},
    { icon: ImagePath.Clubicon, label: 'Clubs & Resort', path: '/clubs-resort',matchPaths: ['/clubs'], roles:[UserRole.Admin, UserRole.Editor,UserRole.Viewer] },
    { icon: ImagePath.Revenewicon, label: 'Revenue Management', path: '/revenue-management', roles:[UserRole.Admin, UserRole.Editor] },
    { icon: ImagePath.Ordericon, label: 'Orders Management', path: '/orders-management', matchPaths:[ '/order'], roles:[UserRole.Admin, UserRole.Editor,UserRole.Viewer] },
    { icon: ImagePath.Transicon, label: 'Transactions', path: '/transactions', roles:[UserRole.Admin, UserRole.Editor] },
    { icon: ImagePath.Couponicon, label: 'Coupons', path: '/coupon', roles:[UserRole.Admin, UserRole.Editor] },
    { icon: ImagePath.Stafficon, label: 'Staff Management', path: '/staff-management', roles:[UserRole.Admin,] },
    // { icon: ImagePath.contactUsSvg, label: 'Contact Us', path: '/contact-us',roles:[UserRole.Admin, UserRole.Editor,UserRole.Viewer] },
    // { icon: ImagePath.ClubRequests, label: 'Explore Clubs Requests', path: '/explore-clubs', roles:[UserRole.Admin, UserRole.Editor,UserRole.Viewer] }

  ];

const filteredMenu = menuItems.filter(item =>
  item.roles.some(role =>
    role?.toLowerCase() === userRole?.toLowerCase()
  )
);

  return (
    <div className="w-[285px] bg-white flex flex-col h-full flex-shrink-0">
      {/* Logo */}
      <div className="p-5">
        <img className="w-36 h-[72px]" alt="DRS Logo" src={ImagePath.DRSLogo} />
      </div>

      {/* Menu Items */}
      <nav className="flex-1 mt-8 overflow-y-auto">
        {filteredMenu?.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
           className={({ isActive }) => {
  const extraMatch = item.matchPaths?.some(path =>
    location.pathname.startsWith(path)
  );

  const isActiveRoute = isActive || extraMatch;

  return `group flex items-center gap-2 px-[30px] h-[50px] cursor-pointer sidemenu ${
    isActiveRoute
      ? 'bg-primary text-white shadow-[0px_4px_12px_#0000004c] active-nav'
      : 'text-textcolor hover:bg-gray-100'
  }`;
}}
          >
            <span className="text-lg">
              <img
                src={item.icon}
                className="nav-icon"
                alt={item.label}
              />
            </span>
            <span className="text-lg">{item.label}</span>
          </NavLink>
        ))}

        {/* Logout Button */}
        <button
          onClick={onLogoutClick}
          className="flex items-center gap-2 px-[30px] h-[50px] cursor-pointer text-textcolor hover:bg-gray-100 w-full"
        >
          <span className="text-lg">
            <img src={ImagePath.Logouticon} className="nav-icon" alt="Logout" />
          </span>
          <span className="text-lg">Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
